/**
 * Line-art coloring page for "Dancing, Dancing...".
 * 8.5×11 aspect, thick black outlines on white.
 * Scene: two little children holding hands, twirling with music notes,
 * ribbons, stars, and flowers dancing around them.
 */
export default function ColoringArtDancing() {
  const stroke = "#111111";
  return (
    <svg
      viewBox="0 0 816 1056"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "auto", background: "#FFFFFF" }}
      role="img"
      aria-label="Coloring page: two children dancing"
    >
      <g fill="none" stroke={stroke} strokeWidth="2">
        <text x="408" y="110" textAnchor="middle" fontFamily="'Fredoka', sans-serif" fontSize="52" fill={stroke} stroke="none" fontWeight="700">
          Dancing, Dancing…
        </text>
        <text x="408" y="150" textAnchor="middle" fontFamily="'Caveat', cursive" fontSize="30" fill={stroke} stroke="none">
          — a coloring page by M.K. Bunch
        </text>
      </g>

      <g fill="none" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
        {/* Ground line — a ribbon curve */}
        <path d="M 60 900 Q 300 830 500 900 T 780 880" />
        <path d="M 60 920 Q 300 850 500 920 T 780 900" />

        {/* LEFT CHILD */}
        {/* Head */}
        <circle cx="280" cy="360" r="70" />
        {/* Puffy hair pigtails */}
        <circle cx="220" cy="330" r="30" />
        <circle cx="340" cy="330" r="30" />
        <path d="M 218 300 Q 250 260 320 285" />
        {/* Eyes + smile */}
        <circle cx="258" cy="360" r="6" fill={stroke} stroke="none" />
        <circle cx="302" cy="360" r="6" fill={stroke} stroke="none" />
        <path d="M 258 385 Q 280 405 302 385" />
        {/* Cheek dots */}
        <circle cx="238" cy="380" r="4" />
        <circle cx="322" cy="380" r="4" />
        {/* Neck */}
        <path d="M 260 430 L 260 460" />
        <path d="M 300 430 L 300 460" />
        {/* Dress (triangle/tutu) */}
        <path d="M 200 470 L 360 470 L 400 720 L 160 720 Z" />
        <path d="M 200 470 Q 280 490 360 470" />
        <path d="M 190 555 Q 280 580 370 555" />
        <path d="M 178 640 Q 280 670 382 640" />
        {/* Arms — one raised, one to the side */}
        <path d="M 200 490 Q 130 460 100 400" />
        <path d="M 360 490 Q 420 500 460 520" />
        {/* Hand shapes */}
        <circle cx="98" cy="395" r="14" />
        <circle cx="462" cy="524" r="14" />
        {/* Legs — one bent, one kicked out */}
        <path d="M 220 720 Q 200 800 220 880" />
        <path d="M 340 720 Q 380 800 350 880" />
        {/* Shoes */}
        <ellipse cx="218" cy="890" rx="25" ry="12" />
        <ellipse cx="354" cy="890" rx="25" ry="12" />

        {/* RIGHT CHILD */}
        {/* Head */}
        <circle cx="560" cy="360" r="70" />
        {/* Curly hair — cloud puffs */}
        <path d="M 500 305 Q 490 280 520 280 Q 530 260 560 275 Q 580 255 610 275 Q 630 275 630 300" />
        <circle cx="500" cy="315" r="18" />
        <circle cx="620" cy="315" r="18" />
        {/* Eyes + smile */}
        <path d="M 534 355 Q 542 345 548 355" />
        <path d="M 574 355 Q 582 345 588 355" />
        <path d="M 534 385 Q 560 410 588 385" />
        <circle cx="510" cy="385" r="4" />
        <circle cx="612" cy="385" r="4" />
        {/* Neck */}
        <path d="M 540 430 L 540 460" />
        <path d="M 580 430 L 580 460" />
        {/* Shirt + shorts */}
        <path d="M 480 470 L 640 470 L 660 620 L 460 620 Z" />
        <path d="M 480 470 Q 560 490 640 470" />
        <path d="M 470 550 Q 560 578 650 550" />
        {/* Belt */}
        <path d="M 460 620 L 660 620" />
        {/* Shorts */}
        <path d="M 460 620 L 480 740 L 560 740 L 560 620" />
        <path d="M 560 620 L 560 740 L 640 740 L 660 620" />
        {/* Arms — both raised, holding hands with left child */}
        <path d="M 480 490 Q 470 470 460 524" />
        <path d="M 640 490 Q 720 470 750 400" />
        {/* Hand shape (right) */}
        <circle cx="752" cy="395" r="14" />
        {/* Legs mid-hop */}
        <path d="M 500 740 Q 470 820 500 890" />
        <path d="M 620 740 Q 660 820 620 890" />
        {/* Shoes */}
        <ellipse cx="500" cy="898" rx="25" ry="12" />
        <ellipse cx="620" cy="898" rx="25" ry="12" />

        {/* MUSIC NOTES + STARS floating */}
        {/* Note 1 */}
        <ellipse cx="120" cy="230" rx="14" ry="10" transform="rotate(-10 120 230)" />
        <path d="M 134 226 L 134 180" />
        <path d="M 134 180 Q 165 180 165 210" />
        {/* Note 2 */}
        <ellipse cx="700" cy="250" rx="14" ry="10" transform="rotate(12 700 250)" />
        <path d="M 714 244 L 714 200" />
        <path d="M 714 200 L 758 190" />
        <ellipse cx="758" cy="200" rx="12" ry="8" />

        {/* Sparkles */}
        <path d="M 80 500 l 6 -14 l 6 14 l 14 6 l -14 6 l -6 14 l -6 -14 l -14 -6 z" />
        <path d="M 720 500 l 6 -14 l 6 14 l 14 6 l -14 6 l -6 14 l -6 -14 l -14 -6 z" />
        <path d="M 400 250 l 5 -12 l 5 12 l 12 5 l -12 5 l -5 12 l -5 -12 l -12 -5 z" />

        {/* Ribbons swirls */}
        <path d="M 40 700 Q 90 660 120 720 Q 100 780 60 760" />
        <path d="M 780 720 Q 720 680 700 740 Q 720 800 770 780" />

        {/* Ground flowers */}
        <g>
          {[100, 220, 400, 600, 720].map((x, i) => (
            <g key={i} transform={`translate(${x} 960)`}>
              <circle r="9" />
              <circle r="3" />
              <path d="M 0 12 L 0 30" />
              <path d="M -10 8 Q -18 22 -8 24" />
              <path d="M 10 8 Q 18 22 8 24" />
            </g>
          ))}
        </g>
      </g>

      <text x="408" y="1030" textAnchor="middle" fontFamily="'Caveat', cursive" fontSize="32" fill={stroke}>
        Clap, twirl, jump, and giggle — color like you dance! ✿
      </text>
    </svg>
  );
}
